import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type OrganizationGroupsTableItemFragment = { __typename: 'OrganizationGroup', id: string, name: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null }> };

export type OrganizationGroupsTableItemsQueryVariables = Types.Exact<{
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type OrganizationGroupsTableItemsQuery = { __typename: 'Query', totalCount: number, items: Array<{ __typename: 'OrganizationGroup', id: string, name: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null }> } | null> };

export type CreateOrganizationGroupsTableItemMutationVariables = Types.Exact<{
  input: Types.MutationCreateOrganizationGroupInput;
}>;


export type CreateOrganizationGroupsTableItemMutation = { __typename: 'Mutation', createOrganizationGroup: { __typename: 'OrganizationGroup', id: string, name: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null }> } };

export type UpdateOrganizationGroupsTableItemMutationVariables = Types.Exact<{
  input: Types.MutationUpdateOrganizationGroupInput;
}>;


export type UpdateOrganizationGroupsTableItemMutation = { __typename: 'Mutation', updateOrganizationGroup: { __typename: 'OrganizationGroup', id: string, name: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null }> } };

export type DeleteOrganizationGroupsTableItemMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteOrganizationGroupsTableItemMutation = { __typename: 'Mutation', deleteOrganizationGroup?: any | null };

export const OrganizationGroupsTableItemFragmentDoc = gql`
    fragment OrganizationGroupsTableItem on OrganizationGroup {
  id
  name
  organizations {
    id
    name
  }
}
    `;
export const OrganizationGroupsTableItemsDocument = gql`
    query organizationGroupsTableItems($take: Int, $skip: Int) {
  items: organizationGroups(
    take: $take
    skip: $skip
    orderBy: [{key: name, direction: asc}]
  ) {
    ...OrganizationGroupsTableItem
  }
  totalCount: organizationGroupsCount
}
    ${OrganizationGroupsTableItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationGroupsTableItemsGQL extends Apollo.Query<OrganizationGroupsTableItemsQuery, OrganizationGroupsTableItemsQueryVariables> {
    override document = OrganizationGroupsTableItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrganizationGroupsTableItemDocument = gql`
    mutation createOrganizationGroupsTableItem($input: MutationCreateOrganizationGroupInput!) {
  createOrganizationGroup(input: $input) {
    ...OrganizationGroupsTableItem
  }
}
    ${OrganizationGroupsTableItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrganizationGroupsTableItemGQL extends Apollo.Mutation<CreateOrganizationGroupsTableItemMutation, CreateOrganizationGroupsTableItemMutationVariables> {
    override document = CreateOrganizationGroupsTableItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrganizationGroupsTableItemDocument = gql`
    mutation updateOrganizationGroupsTableItem($input: MutationUpdateOrganizationGroupInput!) {
  updateOrganizationGroup(input: $input) {
    ...OrganizationGroupsTableItem
  }
}
    ${OrganizationGroupsTableItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrganizationGroupsTableItemGQL extends Apollo.Mutation<UpdateOrganizationGroupsTableItemMutation, UpdateOrganizationGroupsTableItemMutationVariables> {
    override document = UpdateOrganizationGroupsTableItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOrganizationGroupsTableItemDocument = gql`
    mutation deleteOrganizationGroupsTableItem($id: ID!) {
  deleteOrganizationGroup(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOrganizationGroupsTableItemGQL extends Apollo.Mutation<DeleteOrganizationGroupsTableItemMutation, DeleteOrganizationGroupsTableItemMutationVariables> {
    override document = DeleteOrganizationGroupsTableItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }